module.exports = __webpack_public_path__ + "static/media/vias_Master.c2d002a1.jpeg";